module.exports = __webpack_public_path__ + "static/media/add.00ce56c4.png";